// const xahn = [
//     {
//         "id": "11497",
//         "code": "09877",
//         "name": "An Khánh",
//         "name_en": "An Khanh",
//         "full_name": "Xã An Khánh",
//         "full_name_en": "An Khanh Commune"
//     },
//     {
//         "id": "11486",
//         "code": "09700",
//         "name": "Ba Vì",
//         "name_en": "Ba Vi",
//         "full_name": "Xã Ba Vì",
//         "full_name_en": "Ba Vi Commune"
//     },
//     {
//         "id": "11405",
//         "code": "00004",
//         "name": "Ba Đình",
//         "name_en": "Ba Dinh",
//         "full_name": "Phường Ba Đình",
//         "full_name_en": "Ba Dinh Ward"
//     },
//     {
//         "id": "11427",
//         "code": "00292",
//         "name": "Bạch Mai",
//         "name_en": "Bach Mai",
//         "full_name": "Phường Bạch Mai",
//         "full_name_en": "Bach Mai Ward"
//     },
//     {
//         "id": "11484",
//         "code": "09676",
//         "name": "Bất Bạt",
//         "name_en": "Bat Bat",
//         "full_name": "Xã Bất Bạt",
//         "full_name_en": "Bat Bat Commune"
//     },
//     {
//         "id": "11469",
//         "code": "00577",
//         "name": "Bát Tràng",
//         "name_en": "Bat Trang",
//         "full_name": "Xã Bát Tràng",
//         "full_name_en": "Bat Trang Commune"
//     },
//     {
//         "id": "11512",
//         "code": "10126",
//         "name": "Bình Minh",
//         "name_en": "Binh Minh",
//         "full_name": "Xã Bình Minh",
//         "full_name_en": "Binh Minh Commune"
//     },
//     {
//         "id": "11413",
//         "code": "00118",
//         "name": "Bồ Đề",
//         "name_en": "Bo De",
//         "full_name": "Phường Bồ Đề",
//         "full_name_en": "Bo De Ward"
//     },
//     {
//         "id": "11418",
//         "code": "00166",
//         "name": "Cầu Giấy",
//         "name_en": "Cau Giay",
//         "full_name": "Phường Cầu Giấy",
//         "full_name_en": "Cau Giay Ward"
//     },
//     {
//         "id": "11518",
//         "code": "10237",
//         "name": "Chương Dương",
//         "name_en": "Chuong Duong",
//         "full_name": "Xã Chương Dương",
//         "full_name_en": "Chuong Duong Commune"
//     },
//     {
//         "id": "11455",
//         "code": "10015",
//         "name": "Chương Mỹ",
//         "name_en": "Chuong My",
//         "full_name": "Phường Chương Mỹ",
//         "full_name_en": "Chuong My Ward"
//     },
//     {
//         "id": "11521",
//         "code": "10330",
//         "name": "Chuyên Mỹ",
//         "name_en": "Chuyen My",
//         "full_name": "Xã Chuyên Mỹ",
//         "full_name_en": "Chuyen My Commune"
//     },
//     {
//         "id": "11481",
//         "code": "09634",
//         "name": "Cổ Đô",
//         "name_en": "Co Do",
//         "full_name": "Xã Cổ Đô",
//         "full_name_en": "Co Do Commune"
//     },
//     {
//         "id": "11409",
//         "code": "00082",
//         "name": "Cửa Nam",
//         "name_en": "Cua Nam",
//         "full_name": "Phường Cửa Nam",
//         "full_name_en": "Cua Nam Ward"
//     },
//     {
//         "id": "11514",
//         "code": "10180",
//         "name": "Dân Hòa",
//         "name_en": "Dan Hoa",
//         "full_name": "Xã Dân Hòa",
//         "full_name_en": "Dan Hoa Commune"
//     },
//     {
//         "id": "11495",
//         "code": "09856",
//         "name": "Dương Hòa",
//         "name_en": "Duong Hoa",
//         "full_name": "Xã Dương Hòa",
//         "full_name_en": "Duong Hoa Commune"
//     },
//     {
//         "id": "11454",
//         "code": "09886",
//         "name": "Dương Nội",
//         "name_en": "Duong Noi",
//         "full_name": "Phường Dương Nội",
//         "full_name_en": "Duong Noi Ward"
//     },
//     {
//         "id": "11468",
//         "code": "00565",
//         "name": "Gia Lâm",
//         "name_en": "Gia Lam",
//         "full_name": "Xã Gia Lâm",
//         "full_name_en": "Gia Lam Commune"
//     },
//     {
//         "id": "11407",
//         "code": "00025",
//         "name": "Giảng Võ",
//         "name_en": "Giang Vo",
//         "full_name": "Phường Giảng Võ",
//         "full_name_en": "Giang Vo Ward"
//     },
//     {
//         "id": "11503",
//         "code": "09982",
//         "name": "Hạ Bằng",
//         "name_en": "Ha Bang",
//         "full_name": "Xã Hạ Bằng",
//         "full_name_en": "Ha Bang Commune"
//     },
//     {
//         "id": "11449",
//         "code": "09556",
//         "name": "Hà Đông",
//         "name_en": "Ha Dong",
//         "full_name": "Phường Hà Đông",
//         "full_name_en": "Ha Dong Ward"
//     },
//     {
//         "id": "11425",
//         "code": "00256",
//         "name": "Hai Bà Trưng",
//         "name_en": "Hai Ba Trung",
//         "full_name": "Phường Hai Bà Trưng",
//         "full_name_en": "Hai Ba Trung Ward"
//     },
//     {
//         "id": "11490",
//         "code": "09772",
//         "name": "Hát Môn",
//         "name_en": "Hat Mon",
//         "full_name": "Xã Hát Môn",
//         "full_name_en": "Hat Mon Commune"
//     },
//     {
//         "id": "11504",
//         "code": "09988",
//         "name": "Hòa Lạc",
//         "name_en": "Hoa Lac",
//         "full_name": "Xã Hòa Lạc",
//         "full_name_en": "Hoa Lac Commune"
//     },
//     {
//         "id": "11510",
//         "code": "10096",
//         "name": "Hòa Phú",
//         "name_en": "Hoa Phu",
//         "full_name": "Xã Hòa Phú",
//         "full_name_en": "Hoa Phu Commune"
//     },
//     {
//         "id": "11526",
//         "code": "10417",
//         "name": "Hòa Xá",
//         "name_en": "Hoa Xa",
//         "full_name": "Xã Hòa Xá",
//         "full_name_en": "Hoa Xa Commune"
//     },
//     {
//         "id": "11494",
//         "code": "09832",
//         "name": "Hoài Đức",
//         "name_en": "Hoai Duc",
//         "full_name": "Xã Hoài Đức",
//         "full_name_en": "Hoai Duc Commune"
//     },
//     {
//         "id": "11408",
//         "code": "00070",
//         "name": "Hoàn Kiếm",
//         "name_en": "Hoan Kiem",
//         "full_name": "Phường Hoàn Kiếm",
//         "full_name_en": "Hoan Kiem Ward"
//     },
//     {
//         "id": "11433",
//         "code": "00337",
//         "name": "Hoàng Liệt",
//         "name_en": "Hoang Liet",
//         "full_name": "Phường Hoàng Liệt",
//         "full_name_en": "Hoang Liet Ward"
//     },
//     {
//         "id": "11432",
//         "code": "00331",
//         "name": "Hoàng Mai",
//         "name_en": "Hoang Mai",
//         "full_name": "Phường Hoàng Mai",
//         "full_name_en": "Hoang Mai Ward"
//     },
//     {
//         "id": "11411",
//         "code": "00097",
//         "name": "Hồng Hà",
//         "name_en": "Hong Ha",
//         "full_name": "Phường Hồng Hà",
//         "full_name_en": "Hong Ha Ward"
//     },
//     {
//         "id": "11529",
//         "code": "10465",
//         "name": "Hồng Sơn",
//         "name_en": "Hong Son",
//         "full_name": "Xã Hồng Sơn",
//         "full_name_en": "Hong Son Commune"
//     },
//     {
//         "id": "11516",
//         "code": "10210",
//         "name": "Hồng Vân",
//         "name_en": "Hong Van",
//         "full_name": "Xã Hồng Vân",
//         "full_name_en": "Hong Van Commune"
//     },
//     {
//         "id": "11500",
//         "code": "09931",
//         "name": "Hưng Đạo",
//         "name_en": "Hung Dao",
//         "full_name": "Xã Hưng Đạo",
//         "full_name_en": "Hung Dao Commune"
//     },
//     {
//         "id": "11530",
//         "code": "10489",
//         "name": "Hương Sơn",
//         "name_en": "Huong Son",
//         "full_name": "Xã Hương Sơn",
//         "full_name_en": "Huong Son Commune"
//     },
//     {
//         "id": "11436",
//         "code": "00364",
//         "name": "Khương Đình",
//         "name_en": "Khuong Dinh",
//         "full_name": "Phường Khương Đình",
//         "full_name_en": "Khuong Dinh Ward"
//     },
//     {
//         "id": "11448",
//         "code": "09552",
//         "name": "Kiến Hưng",
//         "name_en": "Kien Hung",
//         "full_name": "Phường Kiến Hưng",
//         "full_name_en": "Kien Hung Ward"
//     },
//     {
//         "id": "11499",
//         "code": "09910",
//         "name": "Kiều Phú",
//         "name_en": "Kieu Phu",
//         "full_name": "Xã Kiều Phú",
//         "full_name_en": "Kieu Phu Commune"
//     },
//     {
//         "id": "11457",
//         "code": "00382",
//         "name": "Kim Anh",
//         "name_en": "Kim Anh",
//         "full_name": "Xã Kim Anh",
//         "full_name_en": "Kim Anh Commune"
//     },
//     {
//         "id": "11423",
//         "code": "00229",
//         "name": "Kim Liên",
//         "name_en": "Kim Lien",
//         "full_name": "Phường Kim Liên",
//         "full_name_en": "Kim Lien Ward"
//     },
//     {
//         "id": "11421",
//         "code": "00199",
//         "name": "Láng",
//         "name_en": "Lang",
//         "full_name": "Phường Láng",
//         "full_name_en": "Lang Ward"
//     },
//     {
//         "id": "11492",
//         "code": "09787",
//         "name": "Liên Minh",
//         "name_en": "Lien Minh",
//         "full_name": "Xã Liên Minh",
//         "full_name_en": "Lien Minh Commune"
//     },
//     {
//         "id": "11431",
//         "code": "00328",
//         "name": "Lĩnh Nam",
//         "name_en": "Linh Nam",
//         "full_name": "Phường Lĩnh Nam",
//         "full_name_en": "Linh Nam Ward"
//     },
//     {
//         "id": "11416",
//         "code": "00145",
//         "name": "Long Biên",
//         "name_en": "Long Bien",
//         "full_name": "Phường Long Biên",
//         "full_name_en": "Long Bien Ward"
//     },
//     {
//         "id": "11478",
//         "code": "09022",
//         "name": "Mê Linh",
//         "name_en": "Me Linh",
//         "full_name": "Xã Mê Linh",
//         "full_name_en": "Me Linh Commune"
//     },
//     {
//         "id": "11482",
//         "code": "09661",
//         "name": "Minh Châu",
//         "name_en": "Minh Chau",
//         "full_name": "Xã Minh Châu",
//         "full_name_en": "Minh Chau Commune"
//     },
//     {
//         "id": "11527",
//         "code": "10441",
//         "name": "Mỹ Đức",
//         "name_en": "My Duc",
//         "full_name": "Xã Mỹ Đức",
//         "full_name_en": "My Duc Commune"
//     },
//     {
//         "id": "11473",
//         "code": "00685",
//         "name": "Nam Phù",
//         "name_en": "Nam Phu",
//         "full_name": "Xã Nam Phù",
//         "full_name_en": "Nam Phu Commune"
//     },
//     {
//         "id": "11417",
//         "code": "00160",
//         "name": "Nghĩa Đô",
//         "name_en": "Nghia Do",
//         "full_name": "Phường Nghĩa Đô",
//         "full_name_en": "Nghia Do Ward"
//     },
//     {
//         "id": "11406",
//         "code": "00008",
//         "name": "Ngọc Hà",
//         "name_en": "Ngoc Ha",
//         "full_name": "Phường Ngọc Hà",
//         "full_name_en": "Ngoc Ha Ward"
//     },
//     {
//         "id": "11472",
//         "code": "00679",
//         "name": "Ngọc Hồi",
//         "name_en": "Ngoc Hoi",
//         "full_name": "Xã Ngọc Hồi",
//         "full_name_en": "Ngoc Hoi Commune"
//     },
//     {
//         "id": "11460",
//         "code": "00433",
//         "name": "Nội Bài",
//         "name_en": "Noi Bai",
//         "full_name": "Xã Nội Bài",
//         "full_name_en": "Noi Bai Commune"
//     },
//     {
//         "id": "11420",
//         "code": "00190",
//         "name": "Ô Chợ Dừa",
//         "name_en": "O Cho Dua",
//         "full_name": "Phường Ô Chợ Dừa",
//         "full_name_en": "O Cho Dua Ward"
//     },
//     {
//         "id": "11493",
//         "code": "09817",
//         "name": "Ô Diên",
//         "name_en": "O Dien",
//         "full_name": "Xã Ô Diên",
//         "full_name_en": "O Dien Commune"
//     },
//     {
//         "id": "11501",
//         "code": "09952",
//         "name": "Phú Cát",
//         "name_en": "Phu Cat",
//         "full_name": "Xã Phú Cát",
//         "full_name_en": "Phu Cat Commune"
//     },
//     {
//         "id": "11443",
//         "code": "00619",
//         "name": "Phú Diễn",
//         "name_en": "Phu Dien",
//         "full_name": "Phường Phú Diễn",
//         "full_name_en": "Phu Dien Ward"
//     },
//     {
//         "id": "11451",
//         "code": "09568",
//         "name": "Phú Lương",
//         "name_en": "Phu Luong",
//         "full_name": "Phường Phú Lương",
//         "full_name_en": "Phu Luong Ward"
//     },
//     {
//         "id": "11506",
//         "code": "10030",
//         "name": "Phú Nghĩa",
//         "name_en": "Phu Nghia",
//         "full_name": "Xã Phú Nghĩa",
//         "full_name_en": "Phu Nghia Commune"
//     },
//     {
//         "id": "11410",
//         "code": "00091",
//         "name": "Phú Thượng",
//         "name_en": "Phu Thuong",
//         "full_name": "Phường Phú Thượng",
//         "full_name_en": "Phu Thuong Ward"
//     },
//     {
//         "id": "11519",
//         "code": "10273",
//         "name": "Phú Xuyên",
//         "name_en": "Phu Xuyen",
//         "full_name": "Xã Phú Xuyên",
//         "full_name_en": "Phu Xuyen Commune"
//     },
//     {
//         "id": "11466",
//         "code": "00541",
//         "name": "Phù Đổng",
//         "name_en": "Phu Dong",
//         "full_name": "Xã Phù Đổng",
//         "full_name_en": "Phu Dong Commune"
//     },
//     {
//         "id": "11489",
//         "code": "09739",
//         "name": "Phúc Lộc",
//         "name_en": "Phuc Loc",
//         "full_name": "Xã Phúc Lộc",
//         "full_name_en": "Phuc Loc Commune"
//     },
//     {
//         "id": "11415",
//         "code": "00136",
//         "name": "Phúc Lợi",
//         "name_en": "Phuc Loi",
//         "full_name": "Phường Phúc Lợi",
//         "full_name_en": "Phuc Loi Ward"
//     },
//     {
//         "id": "11528",
//         "code": "10459",
//         "name": "Phúc Sơn",
//         "name_en": "Phuc Son",
//         "full_name": "Xã Phúc Sơn",
//         "full_name_en": "Phuc Son Commune"
//     },
//     {
//         "id": "11462",
//         "code": "00466",
//         "name": "Phúc Thịnh",
//         "name_en": "Phuc Thinh",
//         "full_name": "Xã Phúc Thịnh",
//         "full_name_en": "Phuc Thinh Commune"
//     },
//     {
//         "id": "11488",
//         "code": "09715",
//         "name": "Phúc Thọ",
//         "name_en": "Phuc Tho",
//         "full_name": "Xã Phúc Thọ",
//         "full_name_en": "Phuc Tho Commune"
//     },
//     {
//         "id": "11520",
//         "code": "10279",
//         "name": "Phượng Dực",
//         "name_en": "Phuong Duc",
//         "full_name": "Xã Phượng Dực",
//         "full_name_en": "Phuong Duc Commune"
//     },
//     {
//         "id": "11435",
//         "code": "00352",
//         "name": "Phương Liệt",
//         "name_en": "Phuong Liet",
//         "full_name": "Phường Phương Liệt",
//         "full_name_en": "Phuong Liet Ward"
//     },
//     {
//         "id": "11508",
//         "code": "10072",
//         "name": "Quảng Bị",
//         "name_en": "Quang Bi",
//         "full_name": "Xã Quảng Bị",
//         "full_name_en": "Quang Bi Commune"
//     },
//     {
//         "id": "11475",
//         "code": "08974",
//         "name": "Quang Minh",
//         "name_en": "Quang Minh",
//         "full_name": "Xã Quang Minh",
//         "full_name_en": "Quang Minh Commune"
//     },
//     {
//         "id": "11480",
//         "code": "09619",
//         "name": "Quảng Oai",
//         "name_en": "Quang Oai",
//         "full_name": "Xã Quảng Oai",
//         "full_name_en": "Quang Oai Commune"
//     },
//     {
//         "id": "11498",
//         "code": "09895",
//         "name": "Quốc Oai",
//         "name_en": "Quoc Oai",
//         "full_name": "Xã Quốc Oai",
//         "full_name_en": "Quoc Oai Commune"
//     },
//     {
//         "id": "11456",
//         "code": "00376",
//         "name": "Sóc Sơn",
//         "name_en": "Soc Son",
//         "full_name": "Xã Sóc Sơn",
//         "full_name_en": "Soc Son Commune"
//     },
//     {
//         "id": "11452",
//         "code": "09574",
//         "name": "Sơn Tây",
//         "name_en": "Son Tay",
//         "full_name": "Phường Sơn Tây",
//         "full_name_en": "Son Tay Ward"
//     },
//     {
//         "id": "11496",
//         "code": "09871",
//         "name": "Sơn Đồng",
//         "name_en": "Son Dong",
//         "full_name": "Xã Sơn Đồng",
//         "full_name_en": "Son Dong Commune"
//     },
//     {
//         "id": "11485",
//         "code": "09694",
//         "name": "Suối Hai",
//         "name_en": "Suoi Hai",
//         "full_name": "Xã Suối Hai",
//         "full_name_en": "Suoi Hai Commune"
//     },
//     {
//         "id": "11513",
//         "code": "10144",
//         "name": "Tam Hưng",
//         "name_en": "Tam Hung",
//         "full_name": "Xã Tam Hưng",
//         "full_name_en": "Tam Hung Commune"
//     },
//     {
//         "id": "11412",
//         "code": "00103",
//         "name": "Tây Hồ",
//         "name_en": "Tay Ho",
//         "full_name": "Phường Tây Hồ",
//         "full_name_en": "Tay Ho Ward"
//     },
//     {
//         "id": "11445",
//         "code": "00634",
//         "name": "Tây Mỗ",
//         "name_en": "Tay Mo",
//         "full_name": "Phường Tây Mỗ",
//         "full_name_en": "Tay Mo Ward"
//     },
//     {
//         "id": "11505",
//         "code": "10003",
//         "name": "Tây Phương",
//         "name_en": "Tay Phuong",
//         "full_name": "Xã Tây Phương",
//         "full_name_en": "Tay Phuong Commune"
//     },
//     {
//         "id": "11442",
//         "code": "00613",
//         "name": "Tây Tựu",
//         "name_en": "Tay Tuu",
//         "full_name": "Phường Tây Tựu",
//         "full_name_en": "Tay Tuu Ward"
//     },
//     {
//         "id": "11502",
//         "code": "09955",
//         "name": "Thạch Thất",
//         "name_en": "Thach That",
//         "full_name": "Xã Thạch Thất",
//         "full_name_en": "Thach That Commune"
//     },
//     {
//         "id": "11447",
//         "code": "00643",
//         "name": "Thanh Liệt",
//         "name_en": "Thanh Liet",
//         "full_name": "Phường Thanh Liệt",
//         "full_name_en": "Thanh Liet Ward"
//     },
//     {
//         "id": "11511",
//         "code": "10114",
//         "name": "Thanh Oai",
//         "name_en": "Thanh Oai",
//         "full_name": "Xã Thanh Oai",
//         "full_name_en": "Thanh Oai Commune"
//     },
//     {
//         "id": "11470",
//         "code": "00640",
//         "name": "Thanh Trì",
//         "name_en": "Thanh Tri",
//         "full_name": "Xã Thanh Trì",
//         "full_name_en": "Thanh Tri Commune"
//     },
//     {
//         "id": "11437",
//         "code": "00367",
//         "name": "Thanh Xuân",
//         "name_en": "Thanh Xuan",
//         "full_name": "Phường Thanh Xuân",
//         "full_name_en": "Thanh Xuan Ward"
//     },
//     {
//         "id": "11464",
//         "code": "00493",
//         "name": "Thiên Lộc",
//         "name_en": "Thien Loc",
//         "full_name": "Xã Thiên Lộc",
//         "full_name_en": "Thien Loc Commune"
//     },
//     {
//         "id": "11463",
//         "code": "00475",
//         "name": "Thư Lâm",
//         "name_en": "Thu Lam",
//         "full_name": "Xã Thư Lâm",
//         "full_name_en": "Thu Lam Commune"
//     },
//     {
//         "id": "11467",
//         "code": "00562",
//         "name": "Thuận An",
//         "name_en": "Thuan An",
//         "full_name": "Xã Thuận An",
//         "full_name_en": "Thuan An Commune"
//     },
//     {
//         "id": "11439",
//         "code": "00598",
//         "name": "Thượng Cát",
//         "name_en": "Thuong Cat",
//         "full_name": "Phường Thượng Cát",
//         "full_name_en": "Thuong Cat Ward"
//     },
//     {
//         "id": "11517",
//         "code": "10231",
//         "name": "Thượng Phúc",
//         "name_en": "Thuong Phuc",
//         "full_name": "Xã Thượng Phúc",
//         "full_name_en": "Thuong Phuc Commune"
//     },
//     {
//         "id": "11515",
//         "code": "10183",
//         "name": "Thường Tín",
//         "name_en": "Thuong Tin",
//         "full_name": "Xã Thường Tín",
//         "full_name_en": "Thuong Tin Commune"
//     },
//     {
//         "id": "11477",
//         "code": "08995",
//         "name": "Tiến Thắng",
//         "name_en": "Tien Thang",
//         "full_name": "Xã Tiến Thắng",
//         "full_name_en": "Tien Thang Commune"
//     },
//     {
//         "id": "11509",
//         "code": "10081",
//         "name": "Trần Phú",
//         "name_en": "Tran Phu",
//         "full_name": "Xã Trần Phú",
//         "full_name_en": "Tran Phu Commune"
//     },
//     {
//         "id": "11458",
//         "code": "00385",
//         "name": "Trung Giã",
//         "name_en": "Trung Gia",
//         "full_name": "Xã Trung Giã",
//         "full_name_en": "Trung Gia Commune"
//     },
//     {
//         "id": "11438",
//         "code": "00592",
//         "name": "Từ Liêm",
//         "name_en": "Tu Liem",
//         "full_name": "Phường Từ Liêm",
//         "full_name_en": "Tu Liem Ward"
//     },
//     {
//         "id": "11453",
//         "code": "09604",
//         "name": "Tùng Thiện",
//         "name_en": "Tung Thien",
//         "full_name": "Phường Tùng Thiện",
//         "full_name_en": "Tung Thien Ward"
//     },
//     {
//         "id": "11430",
//         "code": "00322",
//         "name": "Tương Mai",
//         "name_en": "Tuong Mai",
//         "full_name": "Phường Tương Mai",
//         "full_name_en": "Tuong Mai Ward"
//     },
//     {
//         "id": "11525",
//         "code": "10402",
//         "name": "Ứng Hòa",
//         "name_en": "Ung Hoa",
//         "full_name": "Xã Ứng Hòa",
//         "full_name_en": "Ung Hoa Commune"
//     },
//     {
//         "id": "11524",
//         "code": "10369",
//         "name": "Ứng Thiên",
//         "name_en": "Ung Thien",
//         "full_name": "Xã Ứng Thiên",
//         "full_name_en": "Ung Thien Commune"
//     },
//     {
//         "id": "11422",
//         "code": "00226",
//         "name": "Văn Miếu - Quốc Tử Giám",
//         "name_en": "Van Mieu - Quoc Tu Giam",
//         "full_name": "Phường Văn Miếu - Quốc Tử Giám",
//         "full_name_en": "Van Mieu - Quoc Tu Giam Ward"
//     },
//     {
//         "id": "11523",
//         "code": "10354",
//         "name": "Vân Đình",
//         "name_en": "Van Dinh",
//         "full_name": "Xã Vân Đình",
//         "full_name_en": "Van Dinh Commune"
//     },
//     {
//         "id": "11483",
//         "code": "09664",
//         "name": "Vật Lại",
//         "name_en": "Vat Lai",
//         "full_name": "Xã Vật Lại",
//         "full_name_en": "Vat Lai Commune"
//     },
//     {
//         "id": "11414",
//         "code": "00127",
//         "name": "Việt Hưng",
//         "name_en": "Viet Hung",
//         "full_name": "Phường Việt Hưng",
//         "full_name_en": "Viet Hung Ward"
//     },
//     {
//         "id": "11428",
//         "code": "00301",
//         "name": "Vĩnh Hưng",
//         "name_en": "Vinh Hung",
//         "full_name": "Phường Vĩnh Hưng",
//         "full_name_en": "Vinh Hung Ward"
//     },
//     {
//         "id": "11465",
//         "code": "00508",
//         "name": "Vĩnh Thanh",
//         "name_en": "Vinh Thanh",
//         "full_name": "Xã Vĩnh Thanh",
//         "full_name_en": "Vinh Thanh Commune"
//     },
//     {
//         "id": "11426",
//         "code": "00283",
//         "name": "Vĩnh Tuy",
//         "name_en": "Vinh Tuy",
//         "full_name": "Phường Vĩnh Tuy",
//         "full_name_en": "Vinh Tuy Ward"
//     },
//     {
//         "id": "11507",
//         "code": "10045",
//         "name": "Xuân Mai",
//         "name_en": "Xuan Mai",
//         "full_name": "Xã Xuân Mai",
//         "full_name_en": "Xuan Mai Commune"
//     },
//     {
//         "id": "11444",
//         "code": "00622",
//         "name": "Xuân Phương",
//         "name_en": "Xuan Phuong",
//         "full_name": "Phường Xuân Phương",
//         "full_name_en": "Xuan Phuong Ward"
//     },
//     {
//         "id": "11441",
//         "code": "00611",
//         "name": "Xuân Đỉnh",
//         "name_en": "Xuan Dinh",
//         "full_name": "Phường Xuân Đỉnh",
//         "full_name_en": "Xuan Dinh Ward"
//     },
//     {
//         "id": "11487",
//         "code": "09706",
//         "name": "Yên Bài",
//         "name_en": "Yen Bai",
//         "full_name": "Xã Yên Bài",
//         "full_name_en": "Yen Bai Commune"
//     },
//     {
//         "id": "11419",
//         "code": "00175",
//         "name": "Yên Hòa",
//         "name_en": "Yen Hoa",
//         "full_name": "Phường Yên Hòa",
//         "full_name_en": "Yen Hoa Ward"
//     },
//     {
//         "id": "11476",
//         "code": "08980",
//         "name": "Yên Lãng",
//         "name_en": "Yen Lang",
//         "full_name": "Xã Yên Lãng",
//         "full_name_en": "Yen Lang Commune"
//     },
//     {
//         "id": "11450",
//         "code": "09562",
//         "name": "Yên Nghĩa",
//         "name_en": "Yen Nghia",
//         "full_name": "Phường Yên Nghĩa",
//         "full_name_en": "Yen Nghia Ward"
//     },
//     {
//         "id": "11434",
//         "code": "00340",
//         "name": "Yên Sở",
//         "name_en": "Yen So",
//         "full_name": "Phường Yên Sở",
//         "full_name_en": "Yen So Ward"
//     },
//     {
//         "id": "11474",
//         "code": "04930",
//         "name": "Yên Xuân",
//         "name_en": "Yen Xuan",
//         "full_name": "Xã Yên Xuân",
//         "full_name_en": "Yen Xuan Commune"
//     },
//     {
//         "id": "11459",
//         "code": "00430",
//         "name": "Đa Phúc",
//         "name_en": "Da Phuc",
//         "full_name": "Xã Đa Phúc",
//         "full_name_en": "Da Phuc Commune"
//     },
//     {
//         "id": "11446",
//         "code": "00637",
//         "name": "Đại Mỗ",
//         "name_en": "Dai Mo",
//         "full_name": "Phường Đại Mỗ",
//         "full_name_en": "Dai Mo Ward"
//     },
//     {
//         "id": "11471",
//         "code": "00664",
//         "name": "Đại Thanh",
//         "name_en": "Dai Thanh",
//         "full_name": "Xã Đại Thanh",
//         "full_name_en": "Dai Thanh Commune"
//     },
//     {
//         "id": "11522",
//         "code": "10342",
//         "name": "Đại Xuyên",
//         "name_en": "Dai Xuyen",
//         "full_name": "Xã Đại Xuyên",
//         "full_name_en": "Dai Xuyen Commune"
//     },
//     {
//         "id": "11491",
//         "code": "09784",
//         "name": "Đan Phượng",
//         "name_en": "Dan Phuong",
//         "full_name": "Xã Đan Phượng",
//         "full_name_en": "Dan Phuong Commune"
//     },
//     {
//         "id": "11429",
//         "code": "00316",
//         "name": "Định Công",
//         "name_en": "Dinh Cong",
//         "full_name": "Phường Định Công",
//         "full_name_en": "Dinh Cong Ward"
//     },
//     {
//         "id": "11479",
//         "code": "09616",
//         "name": "Đoài Phương",
//         "name_en": "Doai Phuong",
//         "full_name": "Xã Đoài Phương",
//         "full_name_en": "Doai Phuong Commune"
//     },
//     {
//         "id": "11461",
//         "code": "00454",
//         "name": "Đông Anh",
//         "name_en": "Dong Anh",
//         "full_name": "Xã Đông Anh",
//         "full_name_en": "Dong Anh Commune"
//     },
//     {
//         "id": "11440",
//         "code": "00602",
//         "name": "Đông Ngạc",
//         "name_en": "Dong Ngac",
//         "full_name": "Phường Đông Ngạc",
//         "full_name_en": "Dong Ngac Ward"
//     },
//     {
//         "id": "11424",
//         "code": "00235",
//         "name": "Đống Đa",
//         "name_en": "Dong Da",
//         "full_name": "Phường Đống Đa",
//         "full_name_en": "Dong Da Ward"
//     }
// ]



const wardShippingData = [
    { id: "11408", code: "00070", name: "Hoàn Kiếm", distance: "6-7km", shipFee: "30k", taxFee: 30000 },
    { id: "11409", code: "00082", name: "Cửa Nam", distance: "5.5-7.3km", shipFee: "30k", taxFee: 30000 },
    { id: "11405", code: "00004", name: "Ba Đình", distance: "5-7km", shipFee: "28k", taxFee: 28000 },
    { id: "11406", code: "00008", name: "Ngọc Hà", distance: "5-6.5km", shipFee: "29k", taxFee: 29000 },
    { id: "11407", code: "00025", name: "Giảng Võ", distance: "2-5km", shipFee: "23k", taxFee: 23000 },
    { id: "11425", code: "00256", name: "Hai Bà Trưng", distance: "5-7km", shipFee: "33k", taxFee: 33000 },
    { id: "11426", code: "00283", name: "Vĩnh Tuy", distance: "6-8km", shipFee: "36k", taxFee: 36000 },
    { id: "11427", code: "00292", name: "Bạch Mai", distance: "4.5-7km", shipFee: "29k", taxFee: 29000 },
    { id: "11424", code: "00235", name: "Đống Đa", distance: "3-4km", shipFee: "25k", taxFee: 25000 },
    { id: "11423", code: "00229", name: "Kim Liên", distance: "3-4km", shipFee: "25k", taxFee: 25000 },
    { id: "11422", code: "00226", name: "Văn Miếu - Quốc Tử Giám", distance: "4-6km", shipFee: "29k", taxFee: 29000 },
    { id: "11421", code: "00199", name: "Láng", distance: "3-5km", shipFee: "27k", taxFee: 27000 },
    { id: "11420", code: "00190", name: "Ô Chợ Dừa", distance: "3-5km", shipFee: "27k", taxFee: 27000 },
    { id: "11411", code: "00097", name: "Hồng Hà", distance: "7-10km", shipFee: "37k", taxFee: 37000 },
    { id: "11431", code: "00328", name: "Lĩnh Nam", distance: "8-9km", shipFee: "36k", taxFee: 36000 },
    { id: "11432", code: "00331", name: "Hoàng Mai", distance: "4-8km", shipFee: "31k", taxFee: 31000 },
    { id: "11428", code: "00301", name: "Vĩnh Hưng", distance: "7-9km", shipFee: "35k", taxFee: 35000 },
    { id: "11430", code: "00322", name: "Tương Mai", distance: "4-5.5km", shipFee: "29k", taxFee: 29000 },
    { id: "11429", code: "00316", name: "Định Công", distance: "3-5km", shipFee: "25k", taxFee: 25000 },
    { id: "11433", code: "00337", name: "Hoàng Liệt", distance: "5-7km", shipFee: "32k", taxFee: 32000 },
    { id: "11434", code: "00340", name: "Yên Sở", distance: "7-9km", shipFee: "36k", taxFee: 36000 },
    { id: "11437", code: "00367", name: "Thanh Xuân", distance: "0.5-2km", shipFee: "18k", taxFee: 18000 },
    { id: "11436", code: "00364", name: "Khương Đình", distance: "1-3km", shipFee: "20k", taxFee: 20000 },
    { id: "11435", code: "00352", name: "Phương Liệt", distance: "1.5-2.5km", shipFee: "20k", taxFee: 20000 },
    { id: "11418", code: "00166", name: "Cầu Giấy", distance: "3-5km", shipFee: "25k", taxFee: 25000 },
    { id: "11417", code: "00160", name: "Nghĩa Đô", distance: "5-6km", shipFee: "28k", taxFee: 28000 },
    { id: "11419", code: "00175", name: "Yên Hòa", distance: "1-3km", shipFee: "20k", taxFee: 20000 },
    { id: "11412", code: "00103", name: "Tây Hồ", distance: "6-10km", shipFee: "35k", taxFee: 35000 },
    { id: "11410", code: "00091", name: "Phú Thượng", distance: "7-10km", shipFee: "35k", taxFee: 35000 },
    { id: "11442", code: "00613", name: "Tây Tựu", distance: "10-12km", shipFee: "45k", taxFee: 45000 },
    { id: "11443", code: "00619", name: "Phú Diễn", distance: "6-8km", shipFee: "32k", taxFee: 32000 },
    { id: "11441", code: "00611", name: "Xuân Đỉnh", distance: "7-9km", shipFee: "36k", taxFee: 36000 },
    { id: "11440", code: "00602", name: "Đông Ngạc", distance: "8-11km", shipFee: "39k", taxFee: 39000 },
    { id: "11439", code: "00598", name: "Thượng Cát", distance: "10-12km", shipFee: "45k", taxFee: 45000 },
    { id: "11438", code: "00592", name: "Từ Liêm", distance: "4-7km", shipFee: "31k", taxFee: 31000 },
    { id: "11444", code: "00622", name: "Xuân Phương", distance: "7-10km", shipFee: "37k", taxFee: 37000 },
    { id: "11445", code: "00634", name: "Tây Mỗ", distance: "5-8km", shipFee: "32k", taxFee: 32000 },
    { id: "11446", code: "00637", name: "Đại Mỗ", distance: "3-5km", shipFee: "28k", taxFee: 28000 },
    { id: "11416", code: "00145", name: "Long Biên", distance: "9-12km", shipFee: "41k", taxFee: 41000 },
    { id: "11414", code: "00127", name: "Việt Hưng", distance: "10-12km", shipFee: "45k", taxFee: 45000 },
    { id: "11415", code: "00136", name: "Phúc Lợi", distance: "12-14km", shipFee: "55k", taxFee: 55000 },
    { id: "11449", code: "09556", name: "Hà Đông", distance: "3-6km", shipFee: "26k", taxFee: 26000 },
    { id: "11454", code: "09886", name: "Dương Nội", distance: "7-9km", shipFee: "36k", taxFee: 36000 },
    { id: "11450", code: "09562", name: "Yên Nghĩa", distance: "9-10km", shipFee: "41k", taxFee: 41000 },
    { id: "11451", code: "09568", name: "Phú Lương", distance: "5-8km", shipFee: "30k", taxFee: 30000 },
    { id: "11448", code: "09552", name: "Kiến Hưng", distance: "5-7.5km", shipFee: "28k", taxFee: 28000 },
    { id: "11470", code: "00640", name: "Thanh Trì", distance: "7-10km", shipFee: "36k", taxFee: 36000 },
    { id: "11471", code: "00664", name: "Đại Thanh", distance: "7-10km", shipFee: "36k", taxFee: 36000 },
    { id: "11473", code: "00685", name: "Nam Phù", distance: "10-13km", shipFee: "47k", taxFee: 47000 },
    { id: "11472", code: "00679", name: "Ngọc Hồi", distance: "10-12km", shipFee: "45k", taxFee: 45000 },
    { id: "11447", code: "00643", name: "Thanh Liệt", distance: "3-6km", shipFee: "26k", taxFee: 26000 },

]

export {
    wardShippingData
}
